/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontProductTile_viewer$ref = any;
export type StorefrontProductGrid_viewer$ref = any;
export type StorefrontProductGrid_viewer = {
    readonly " $fragmentRefs": StorefrontProductTile_viewer$ref;
    readonly " $refType": StorefrontProductGrid_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontProductGrid_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontProductTile_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'f1cf5bc5923dd762b08b8db854ff6678';
export default node;
